module.exports = __webpack_public_path__ + "static/media/icon-live-ic-done.5d8f9f94.svg";